module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/nano_04_sp-bbbe48f9ba800298680e7971cd174aa6.png";